import { render, staticRenderFns } from "./ResetFicBic.vue?vue&type=template&id=295ff934&"
import script from "./ResetFicBic.vue?vue&type=script&lang=js&"
export * from "./ResetFicBic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports